export default function TestEvents() {
  return (
    <>
      <header className="relative w-full bg-gray-200 py-2 border-b-black border-b">
        <section className="max-w-[85rem] mx-auto">
          <h2 className="text-center font-serif font-bold text-[110%] md:text-xl italic">Emergency Vehicle Technician Certification Commission</h2>
        </section>
      </header>
      <main className="w-full">
        <div className="max-w-[85rem] mx-auto px-8">
          <section className="mt-4">
            <h1 className="my-2 font-serif text-3xl font-bold italic text-(--darkred)">Testing Events</h1>
            <p className="my-2">This page shows upcoming test events (locations and dates) by state/province. Use the drop-down menu to select your location, and the test events for that locality will load.</p>
            <p className="mb-4"><em className="font-bold">Please note</em>: This page is informational only. To register, begin by logging in at the <a className="my-2 text-(--themered) hover:text-(--darkred) hover:underline" href="https://register.evtcc.org">registration portal</a>.</p>
          </section>
          <iframe title="Test Sites Data Table" src="https://evtcertificationcommission-external.cloud.alphasoftware.com/public_testsites.a5w" className="w-full h-[30em] border-gray-300 border"></iframe>
        </div>
      </main>
    </>
  )
}